// Predictive search: fetches the predictive-search section via Section Rendering. Markets prefix kept through data-url (routes).
const form = document.querySelector('[data-predictive-search]');

if (form) {
  const input = form.querySelector('input[name="q"]');
  const results = form.querySelector('[data-predictive-results]');
  const idle = form.querySelector('[data-predictive-idle]');
  let controller;
  let timer;

  const run = async () => {
    const q = input.value.trim();
    controller?.abort();
    if (q.length < 2) {
      results.innerHTML = '';
      if (idle) idle.hidden = false;
      return;
    }
    controller = new AbortController();
    const url = `${form.dataset.url}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6&section_id=predictive-search`;
    try {
      const res = await fetch(url, { signal: controller.signal });
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      results.innerHTML = doc.querySelector('[data-predictive-content]')?.innerHTML ?? '';
      if (idle) idle.hidden = true;
    } catch (err) {
      if (err.name !== 'AbortError') results.innerHTML = '';
    }
  };

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.preventDefault(); form.closest('dialog')?.close(); }
  });

  input.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(run, 200);
  });
}
